import { createStore } from "jotai";

export const adminStore = createStore();